import { render } from "./BookingCreateFab.vue?vue&type=template&id=700c4cdf"
import script from "./BookingCreateFab.vue?vue&type=script&lang=js"
export * from "./BookingCreateFab.vue?vue&type=script&lang=js"

import exportComponent from "C:\\MartinRud-CloudRoot\\Firma\\Code\\PHP\\byensegenbil.dk\\byensegenbil.dk-2024\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__